import { render, staticRenderFns } from "./JcomTableMembersList.vue?vue&type=template&id=0085d4dd"
import script from "./JcomTableMembersList.vue?vue&type=script&lang=js"
export * from "./JcomTableMembersList.vue?vue&type=script&lang=js"
import style0 from "./JcomTableMembersList.vue?vue&type=style&index=0&id=0085d4dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports